export default function c(...classNames) {
  return classNames.filter(Boolean).join(' ');
}
